import type { PermissionBundle, SupportedLocale } from '@stm/contracts';
import { en, type TranslationKey } from './locales/en.js';
import { hu } from './locales/hu.js';
import { ro } from './locales/ro.js';

export type { SupportedLocale, TranslationKey };
export { supportedLocales } from '@stm/contracts';

export const catalogs = { en, hu, ro } as const;

export function translate(locale: SupportedLocale, key: TranslationKey): string {
  return catalogs[locale][key] ?? en[key];
}

/** Label of each role, shared by the interface and server-rendered e-mails. */
export const bundleLabelKeys: Readonly<Record<PermissionBundle, TranslationKey>> = {
  club_admin: 'roles.bundle.club_admin',
  secretary: 'roles.bundle.secretary',
  finance: 'roles.bundle.finance',
  coach: 'roles.bundle.coach',
  registrar: 'roles.bundle.registrar',
  rules_officer: 'roles.bundle.rules_officer',
  guardian: 'roles.bundle.guardian',
  athlete: 'roles.bundle.athlete',
};
